import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators'
import axios from 'axios'
import { Product } from './product'
import { Market } from './market'

export interface Event {
    description: string,
    userAgent: string,
    data: any,
    eventType: number,
    product: Product,
    market: Market,
    trackingKey: string,
}
export interface PageView {
    key: string,
    title: string,
    pageNo: number,
    sectionName: string,
    duration: number,
}

export enum EventType {
    GVD = 1,
    SLIDE_DECK = 2,
}

@Module
export default class EventStore extends VuexModule {
  @Action async addGenericEvent (event: Event) {
    const result = await axios.post('/events', event, { withCredentials: true })
    const data: Event = result.data
    return data
  }

  @Action async addEvent (event: Event) {
    const result = await axios.post(`/events/${event.eventType}`, event, { withCredentials: true })
    const data: Event = result.data
    return data
  }

  @Action async getPageViews (options: { dateFrom: string, dateTo: string, eventType: EventType, marketKey: string }) {
    const result = await axios.get(`/events/${options.dateFrom}/${options.dateTo}/${options.eventType}/${options.marketKey}`, { withCredentials: true })
    const data: any[] = result.data
    return data
  }
}
